import { MainColor } from '../../palette/colors';

export const getEditLotsThemeConfig = () => {
  return {
    default: {
      border: 'coolGrey10' as MainColor,
      title: 'navy95' as MainColor,
      label: 'coolGrey60' as MainColor,
    },
    form: {
      text: 'coolGrey60' as MainColor,
      lot: {
        idColor: 'forest60' as MainColor,
        root: {
          background: 'coolGrey5' as MainColor,
          borderColor: 'coolGrey10' as MainColor,
          borderStyle: 'solid',
          defaultText: 'navy95' as MainColor,
          contentText: 'coolGrey60' as MainColor,
        },
        child: {
          background: 'coolGrey10' as MainColor,
          borderColor: 'coolGrey20' as MainColor,
          borderStyle: 'solid',
          defaultText: 'navy95' as MainColor,
          contentText: 'coolGrey60' as MainColor,
        },
        merged: {
          background: 'white95' as MainColor,
          borderColor: 'coolGrey30' as MainColor,
          borderStyle: 'dashed',
          defaultText: 'coolGrey60' as MainColor,
          contentText: 'coolGrey60' as MainColor,
        },
      },
    },
    icon: {
      background: 'white95' as MainColor,
      border: 'coolGrey30' as MainColor,
      color: 'coolGrey60' as MainColor,
    },
  };
};
export type EditLotsTheme = ReturnType<typeof getEditLotsThemeConfig>;
